import { useQuery } from '@tanstack/react-query';

export interface State {
  codigo_uf: number;
  uf: string;
  nome: string;
  latitude: number;
  longitude: number;
  regiao: string;
}

const fetchStates = async (): Promise<State[]> => {
  const response = await fetch('/data/estados.json');
  if (!response.ok) {
    throw new Error('Erro ao carregar os estados');
  }
  return response.json();
};

export function useStates() {
  const {
    data: stateData,
    isLoading,
    isFetching,
    isRefetching,
  } = useQuery({
    queryKey: ['states'],
    queryFn: fetchStates,
    staleTime: 1000 * 60 * 60 * 24 * 30, // Cache de 30 dias
  });

  const sortedStateData = stateData?.sort((a, b) =>
    a.nome.localeCompare(b.nome),
  );

  return {
    stateData: sortedStateData || [],
    isLoading: isLoading || isFetching || isRefetching,
  };
}
